import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useAuth } from '@/features/auth';
import { fetchConsentState } from '../api';
import type { ConsentState } from '../types';

export const CONSENT_STATE_QUERY_KEY = 'consent-state';

export function useConsentState() {
  const { user } = useAuth();

  return useQuery<ConsentState>({
    queryKey: [CONSENT_STATE_QUERY_KEY, user?.id],
    queryFn: fetchConsentState,
    enabled: !!user?.id,
    // Der Stand aendert sich nur durch eigene Aktionen oder eine neue
    // Textfassung. Beim Fokuswechsel neu zu laden wuerde das Gate
    // gelegentlich mitten in einer Eingabe neu aufbauen.
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

/** Nach jeder Entscheidung: Gate und Profilanzeige neu bewerten lassen. */
export function useInvalidateConsentState() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [CONSENT_STATE_QUERY_KEY, user?.id] });
  }, [queryClient, user?.id]);
}
